import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import clsx from 'clsx';
import { DropdownSelection } from '../../form/dropdownSelection/DropdownSelection.js';
import { CloseIcon } from '../../icons/CloseIcon.js';
import { IconButton } from '../../base/iconButton/IconButton.js';
import { Card } from '../../base/card/Card.js';
import { Policy } from './policy/Policy.js';
import styles from './PoliciesDropdown.module.scss.js';
import { Skeleton } from './skeleton/Skeleton.js';

var PoliciesDropdown = function (_a) {
    var name = _a.name, policies = _a.policies, inputProps = _a.inputProps, className = _a.className, style = _a.style;
    if (policies.length === 1) {
        return (jsx(Card, __assign({ className: styles.policyCard }, { children: jsx(Policy, __assign({ className: styles.policy }, policies[0])) })));
    }
    return (jsx(DropdownSelection, __assign({ label: "Select policy", header: function (onClose) { return (jsxs(Fragment, { children: ["Select policy", jsx(IconButton, __assign({ "aria-label": "Close", variant: "text", color: "dark", onClick: onClose, size: "xxs" }, { children: jsx(CloseIcon, {}) }))] })); }, name: name, inputProps: inputProps, className: clsx(className, styles.policy), listboxClassName: styles.policiesListbox, style: style }, { children: policies.map(function (policy) { return (jsx(DropdownSelection.Item, __assign({ textValue: policy.name, className: styles.policy }, { children: jsx(Policy, __assign({}, policy)) }), policy.policyNumber)); }) })));
};
PoliciesDropdown.Skeleton = Skeleton;

export { PoliciesDropdown };
